import { isCountryCanada } from "utils/helpers/user";

/**
 * Resolve the effective tenant/account-holder country for patient flows.
 * Priority: authenticated user → public intake → tenant subdomain guest.
 */
export function resolveTenantCountry({ user = null, globals = null, patientIntakeData = null } = {}) {
	if (user?.country) {
		return user.country;
	}
	if (patientIntakeData?.country) {
		return patientIntakeData.country;
	}
	return globals?.tenant_info?.country || "";
}

export function isCanadianTenantCountry(country = "") {
	return isCountryCanada(country);
}

export function isNonCanadianTenantCountry(country = "") {
	return Boolean(country) && !isCanadianTenantCountry(country);
}
